import { render } from "./PoliticaCookies.vue?vue&type=template&id=69d106b3&scoped=true"
import script from "./PoliticaCookies.vue?vue&type=script&lang=js"
export * from "./PoliticaCookies.vue?vue&type=script&lang=js"

import "./PoliticaCookies.vue?vue&type=style&index=0&id=69d106b3&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d106b3"]])

export default __exports__